import { msalInstance } from './msalConfig';
import { allowedUsers } from '@/config/users.ts';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import type { AccountInfo } from '@azure/msal-browser';

export function msalService() {
  const $authStore = useAuthStore();
  const router = useRouter();

  const initialize = async () => {
    try {
      await msalInstance.initialize(); // Call the initialize function
    } catch (error) {
      console.log('Initialization error', error);
    }
  };

  const login = async () => {
    try {
      if (!msalInstance) {
        throw new Error('MSAL not initialized.');
      }
      await msalInstance.loginRedirect();
      $authStore.setAuthenticated(true);
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  const logout = () => {
    if (!msalInstance) {
      throw new Error('MSAL not initialized.');
    }
    // Enable this to logout user from Microsoft Account as well
    // msalInstance.logoutRedirect()

    // Delete msal keys from session storage
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith('msal')) {
        sessionStorage.removeItem(key);
      }
    });

    $authStore.clearAuth();
    router.push({ name: 'login' });
  };

  const handleRedirect = async () => {
    try {
      const redirectResult = await msalInstance.handleRedirectPromise();
      const account: AccountInfo = msalInstance.getAllAccounts()[0];

      let isAuth: boolean = false;
      if (account && allowedUsers.includes(account.username)) {
        isAuth = true;
        $authStore.setUser(account);
      }

      $authStore.setAuthenticated(isAuth);

      if (account && !isAuth) {
        $authStore.setLoginError(`Der Account "${account.username}" ist für diese Anwendung nicht freigeschaltet.`);
        await msalInstance.logoutRedirect();
        return;
      }

      if (redirectResult !== null) {
        // Processing MSAL redirect response
        await router.push(isAuth ? '/' : '/login');
      } else if (!isAuth) {
        // User is not authenticated
        await router.push('/login');
      } else if (isAuth && router.currentRoute.value.name === 'login') {
        // User is authenticated but on the login route
        await router.replace('/');
      }
    } catch (error) {
      console.error('Redirect error:', error);
    }
  };

  return {
    initialize,
    login,
    logout,
    handleRedirect
  };
}
